<template>
  <div>
    <img id="mySpinner" src="loading.gif" v-if="loading" class="center-block" />

    <nav
      class="navbar navbar-default navbar-options"
      role="navigation"
      v-if="!loading"
    >
      <div class="container">
        <div class="navbar-header">
          <div class="back-button">
            <button type="button" class="btn btn-back" @click="voltar()">
              <span class="glyphicon glyphicon-menu-left"></span>
              <span class="sr-only">Submit</span>
            </button>
            <span class="restaurantname"> {{ restaurantName }}</span>
          </div>
        </div>
      </div>
    </nav>

    <div class="container-fluid" v-if="!loading">
      <h4>Telefone para contato</h4>

      <div class="alert alert-danger" v-if="msgError">
        {{ msgError }}
      </div>

      <div class="form-group">
        <the-mask
          :mask="['(##) ####-####', '(##) #####-####']"
          :masked="true"
          type="tel"
          class="form-control sp_celphones"
          v-model="client.phone"
          id="phone"
          required
          placeholder="(DDD) 00000-0000"
          autocomplete="off"
          v-on:keyup.enter="confirmar"
        />
      </div>

      <div id="divSpace"></div>
    </div>

    <div
      class="btn-group btn-group-justified"
      role="group"
      v-if="!loading"
      style="position:fixed; bottom:0; width:100%;"
    >
      <div class="btn-group" role="group">
        <button
          class="btn btn-danger btn-lg"
          @click="confirmar()"
          data-dir="up"
        >
          Próximo
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask'

export default {
  name: 'Phone',
  components: { TheMask },
  data () {
    return {
      loading: false,
      msgError: null,
      session: {},
      client: {}
    }
  },
  computed: {
    aberto: {
      get () {
        return this.$store.state.aberto
      },
      set (value) {
        this.$store.commit('setAberto', value)
      }
    },
    token () {
      return this.$store.state.token
    },
    channelId () {
      return this.$store.state.channelId
    },
    clientId () {
      return this.$store.state.clientId
    },
    code () {
      return this.$store.state.code
    },
    demo () {
      return this.$store.state.demo
    },
    restaurantName () {
      return this.$store.state.restaurantName
    },
    location () {
      return this.$store.state.location
    },
    slug () {
      return this.$store.state.slug
    },
    // Nome diferente por que já existe o objeto session
    tempSession () {
      return this.$store.state.session
    },
    authentication () {
      return this.$store.state.authentication
    }
  },
  mounted () {
    const vm = this
    vm.loading = true
    vm.axios
      .get(`${process.env.VUE_APP_API_URL}/sessions`, {
        headers: {
          Authorization: vm.token
        }
      })
      .then(response => {
        if (!response.data) {
          // vm.closeWebview()
        } else {
          if (vm.token) {
            if (!response.data) {
              // vm.closeWebview()
            } else {
              console.log('buscando dados do cliente')
              vm.axios
                .get(`${process.env.VUE_APP_API_URL}/clients`, {
                  headers: {
                    Authorization: vm.token
                  }
                })
                .then(response => {
                  vm.client = response.data
                  vm.client.phone = ''
                  vm.loading = false
                  document.getElementById('phone').focus()
                  console.log('Dados do cliente carregados.')
                })
                .catch(error => {
                  console.log('Problema ao carregar dados do cliente.')
                  console.log('Error: ' + error)
                  // vm.closeWebview()
                })
            }
          }
        }
      })
      .catch(error => {
        console.log('Problema ao carregar telefone.')
        console.log('Error: ' + error)
        // vm.closeWebview()
      })
  },
  methods: {
    confirmar () {
      const vm = this
      vm.loading = true

      if (!vm.client || (vm.client && !vm.client.phone)) {
        vm.msgError = 'Informe um telefone para contato'
        vm.loading = false
      } else {
        if (vm.client) {
          vm.client.address = null
        }

        vm.axios
          .put(
            `${process.env.VUE_APP_API_URL}/sessions`,
            { client: vm.client },
            {
              headers: {
                Authorization: vm.token
              }
            }
          )
          .then(() => {
            vm.axios
              .patch(
                `${process.env.VUE_APP_API_URL}/clients`,
                { phone: vm.client.phone },
                {
                  headers: {
                    Authorization: vm.token
                  }
                }
              )
              .then(() => {
                if (!vm.client || (vm.client && !vm.client.email)) {
                  // if (t.code) {
                  //   $location.path('/' + t.code + '/email')
                  // } else {
                  //   $location.path('/email/' + t.channelId + '/' + t.clientId)
                  // }
                  if (vm.code) {
                    vm.$router.push({ path: `/${vm.code}/email` })
                  } else if (vm.channelId && vm.clientId) {
                    vm.$router.push({
                      path: `/email/${vm.channelId}/${vm.clientId}`
                    })
                  } else {
                    vm.$router.push({
                      path: `/delivery/email/${vm.location}/${vm.slug}`
                    })
                  }
                } else {
                  // if (vm.code) {
                  //   $location.path('/' + t.code + '/cart')
                  // } else {
                  //   $location.path('/cart/' + t.channelId + '/' + t.clientId)
                  // }
                  if (vm.code) {
                    vm.$router.push({ path: `/${vm.code}/cart` })
                  } else if (vm.channelId && vm.clientId) {
                    vm.$router.push({
                      path: `/cart/${vm.channelId}/${vm.clientId}`
                    })
                  } else {
                    vm.$router.push({
                      path: `/delivery/${vm.location}/${vm.slug}/cart`
                    })
                  }
                }
                vm.loading = false
              })
          })
          .catch(error => {
            vm.loading = false
            console.log('Falha ao atualizar dados da sessão.')
            console.log('Error: ' + error)
          })
      }
    },
    voltar () {
      window.history.back()
    }
    // closeWebview () {
    //   try {
    //     window.MessengerExtensions.requestCloseBrowser(null, null)
    //   } catch (e) {
    //     console.log('MessengerExtensions not supported')
    //   }
    // }
  }
}
</script>
